export const addressBookButtonDesc = "S$d";
export const archiveButtonDesc = "T$d";
export const assignPolicyButtonDesc = "U$d";
export const attachFileButtonDesc = "V$d";
export const attachSignatureButtonDesc = "W$d";
export const blockButtonDesc = "X$d";
export const categorizeButtonDesc = "Y$d";
export const checkNamesButtonDesc = "Z$d";
export const createRuleButtonDesc = "_$d";
export const customizeButtonDesc = "$$d";
export const browseGroupsButtonDesc = "aae";
export const deleteButtonDesc = "bae";
export const discardButtonDesc = "cae";
export const emojiButtonDesc = "dae";
export const encryptButtonDesc = "eae";
export const flagButtonDesc = "fae";
export const flagClearFlagButtonDesc = "gae";
export const flagNextWeekButtonDesc = "hae";
export const flagNoDateButtonDesc = "iae";
export const flagThisWeekButtonDesc = "jae";
export const flagTodayButtonDesc = "kae";
export const flagTomorrowButtonDesc = "lae";
export const flagMarkCompleteButtonDesc = "mae";
export const forwardButtonDesc = "nae";
export const forwardEmailAsAttachmentDesc = "oae";
export const getAddinsButtonDesc = "pae";
export const highImportanceButtonDesc = "qae";
export const ignoreButtonDesc = "rae";
export const immersiveReaderButtonDesc = "sae";
export const junkButtonDesc = "tae";
export const junkFlyoutButtonDesc = "uae";
export const lowImportanceButtonDesc = "vae";
export const manageRulesButtonDesc = "wae";
export const moreRetentionPoliciesButtonDesc = "xae";
export const moveButtonDesc = "yae";
export const newMessageButtonDesc = "zae";
export const normalImportanceButtonDesc = "Aae";
export const phishingButtonDesc = "Bae";
export const pinButtonDesc = "Cae";
export const picturesButtonDesc = "Dae";
export const pollButtonDesc = "Eae";
export const readAloudButtonDesc = "Fae";
export const readUnreadButtonDesc = "Gae";
export const replyButtonDesc = "Hae";
export const replyAllButtonDesc = "Iae";
export const replyWithMeetingButtonDesc = "Jae";
export const rulesButtonDesc = "Kae";
export const sendDraftButtonDesc = "Lae";
export const sensitivityButtonDesc = "Mae";
export const sensitivityLearnMoreButtonDesc = "Nae";
export const showLinkDialogButtonDesc = "Oae";
export const snoozeButtonDesc = "Pae";
export const sweepButtonDesc = "Qae";
export const tableButtonDesc = "Rae";
export const undoButtonDesc = "Sae";
export const deleteNoteDesc = "Tae";
export const changeNoteColorDesc = "Uae";
export const viewEmailFromNotesDesc = "Vae";
export const playMyEmailsDesc = "Wae";
export const layoutDesc = "Xae";
export const messagesDesc = "Yae";
export default {addressBookButtonDesc,archiveButtonDesc,assignPolicyButtonDesc,attachFileButtonDesc,attachSignatureButtonDesc,blockButtonDesc,categorizeButtonDesc,checkNamesButtonDesc,createRuleButtonDesc,customizeButtonDesc,browseGroupsButtonDesc,deleteButtonDesc,discardButtonDesc,emojiButtonDesc,encryptButtonDesc,flagButtonDesc,flagClearFlagButtonDesc,flagNextWeekButtonDesc,flagNoDateButtonDesc,flagThisWeekButtonDesc,flagTodayButtonDesc,flagTomorrowButtonDesc,flagMarkCompleteButtonDesc,forwardButtonDesc,forwardEmailAsAttachmentDesc,getAddinsButtonDesc,highImportanceButtonDesc,ignoreButtonDesc,immersiveReaderButtonDesc,junkButtonDesc,junkFlyoutButtonDesc,lowImportanceButtonDesc,manageRulesButtonDesc,moreRetentionPoliciesButtonDesc,moveButtonDesc,newMessageButtonDesc,normalImportanceButtonDesc,phishingButtonDesc,pinButtonDesc,picturesButtonDesc,pollButtonDesc,readAloudButtonDesc,readUnreadButtonDesc,replyButtonDesc,replyAllButtonDesc,replyWithMeetingButtonDesc,rulesButtonDesc,sendDraftButtonDesc,sensitivityButtonDesc,sensitivityLearnMoreButtonDesc,showLinkDialogButtonDesc,snoozeButtonDesc,sweepButtonDesc,tableButtonDesc,undoButtonDesc,deleteNoteDesc,changeNoteColorDesc,viewEmailFromNotesDesc,playMyEmailsDesc,layoutDesc,messagesDesc};